// Get the current frame's height and width:
const getInnerHeight = () => window.innerHeight;
const getInnerWidth = () => window.innerWidth;

// Get the number of pixels an element's content is scrolled vertically and horizontally
// To get the scroll information of current window, use getElementVerticalScroll(document.body) || getElementVerticalScroll(document.documentElement), because Safari use document.body, while other browsers use document.documentElement.
const getElementVerticalScroll = (ele) => ele.scrollTop;
const getElementHorizontalScroll = (ele) => ele.scrollLeft;

// Get the entire height and width of an element, including padding
const getElementHeight = (ele) => ele.scrollHeight;
// const getElementWidth = ele => ele.scrollWidth;

const getScrollY = () =>
  window.scrollY ||
  getElementVerticalScroll(document.body) ||
  getElementVerticalScroll(document.documentElement);

const setScrollY = (val) => {
  document.body.scrollTop = val;
  document.documentElement.scrollTop = val;
};

const getAvailableHeightForScroll = () => {
  return getElementHeight(document.documentElement) - getInnerHeight();
};

export {
  getScrollY,
  setScrollY,
  getElementHeight,
  getInnerWidth,
  getAvailableHeightForScroll,
  getElementHorizontalScroll,
};
